var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "wrap-icon with-top-tag",
      attrs: { id: `icon-${_vm.icon.name}-${_vm.icon.style}` },
    },
    [
      _c(
        "site-link",
        {
          staticClass:
            "icon button flat display-flex flex-column flex-items-center flex-content-center",
          style: `${_vm.buttonResultsStyle}
      width: 100%;
      height: 100%;
      --button-background: var(--white);
      --button-hover-background: var(--fa-yellow);
      --button-color: var(--fa-md-gravy);
      --button-hover-color: var(--fa-navy);
      --button-font-weight: var(--font-weight-normal);
      --button-margin-bottom: 0;
      --button-color: var(--fa-navy);`,
          attrs: {
            to: _vm.$icon({
              name: _vm.icon.name,
              style: _vm.icon.style,
              family: _vm.icon.family,
            }),
          },
          on: {
            click: function ($event) {
              return _vm.$posthog.capture("icon_link_click", {
                icon_name: _vm.icon.name,
                icon_style: _vm.icon.style,
                icon_family: _vm.icon.family,
              })
            },
          },
        },
        [
          _c("i", {
            class: `${_vm.translatedStyle} fa-${_vm.icon.name} fa-fw`,
          }),
          _vm._v(" "),
          _c("span", { staticClass: "icon-name" }, [
            _vm._v(_vm._s(_vm.icon.name)),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.isShowingProTag
        ? _c("wa-tag", {
            attrs: {
              position: _vm.proTagPosition,
              "position-indent": _vm.proTagPositionIndent,
              size: _vm.proTagSize,
              background: "var(--fa-yellow)",
              color: "var(--fa-navy)",
              explanation: "Using this requires Font Awesome Pro",
              label: "Pro",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }